import React, { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Input from "../utils/Input";
import Button from "../utils/Button";
import toast from "react-hot-toast";


export default function RegisterLayout({role}: {role?: string}) {
  // const [fullName, setFullName] = useState("");
  // const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;

  const token = new URLSearchParams(window.location.search).get("token") || "";

  
   const handleRegister = async (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      setIsLoading(true);
      try {
        toast.loading('Activating account...', { id: 'register-toast' });
       
        await axios.post(`${apiUrl}/auth/accept-invite?token=${token}`, { password });

        toast.success('Account is ready, please log in', { id: 'register-toast' });
        
        switch ((role || '').toLowerCase()) {
          case 'canvasser':
            navigate('/canvasser/login');
            break;
          case 'partner':
            navigate('/partner/login');
            break;
          case 'admin':
            navigate('/admin/login');
            break;
          case 'supervisor':
            navigate('/supervisor/login');
            break;
          default:
            navigate('/admin/login');
        }
      } catch (err) {
        setError('Registration failed');
        console.error(err);
        toast.error('Registration failed. Please try again.', { id: 'register-toast' });
      } finally {
        setIsLoading(false);
      }
    };

  return (
      <form
        onSubmit={handleRegister}
        className="bg-gray-900 p-8 rounded-lg shadow-lg w-full max-w-md animate-fireGlow"
      >
        <h2 className="text-2xl text-white font-bold mb-6 text-center">{role} Register</h2>
        <p className="text-sm text-white text-center pb-5 m-auto">To complete your registration, kindly add a secured password</p>
        {error && <p className="text-red-500 text-sm mb-4">{error}</p>}
        

       

        <Input
          label="Password"
          placeholder="Password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          debounce={0}
          className="mb-6"
          helper="Minimum 8 characters"
          onValidate={(val) => (val && val.length >= 8 ? null : 'Password must be at least 8 characters')}
        />
       
        <Button disabled={!password || password.length < 8 || !token || isLoading} label={isLoading ? "Activating Account..." : "Register"} type="submit" variant="primary" size="extra-large" />
        <p className="mt-4 text-white text-center text-sm">
          Already have an account?{" "}
          <Link to={`/${role?.toLowerCase()}/login`} className="text-blue-400 hover:underline">
            Login
          </Link>
        </p>
      </form>
  );
}
